import type { Execute } from "@reservoir0x/reservoir-sdk";

export function getTxHash(progress: Execute["steps"]) {
    for (const step of progress.toReversed()) {
        for (const item of step?.items?.toReversed() ?? []) {
            const txHash = item.txHashes?.at(-1)?.txHash;
            if (txHash != null) {
                return txHash;
            }
        }
    }
}

export function findAdjustedUsdcPrice(usdPrice: bigint, quantity: bigint) {
    let adjustedPrice: bigint;
    for (adjustedPrice = usdPrice; adjustedPrice >= 0; adjustedPrice -= 1n) {
        const royalty = (adjustedPrice * 25n) / 1000n;
        const validRoyalty = royalty % quantity === 0n;
        if (!validRoyalty) {
            continue;
        }

        // royalty is subtracted twice from the original price (Artist Royalty + Marketplace Fee)
        const netPrice = adjustedPrice - 2n * royalty;

        // Reservoir backend only accepts orders where the quantity is a multiple of the net price
        const isValidOrder = netPrice % quantity === 0n;
        if (isValidOrder) {
            break;
        }
    }

    if (adjustedPrice === 0n) {
        throw new Error("Could not find a valid price");
    }

    return adjustedPrice;
}
